import { AlertTriangle, ShieldAlert, Wrench, ClipboardCheck, KeyRound } from 'lucide-react';
import { WARN_TYPES, daysText } from './utils';

const ICONS = { insurance: ShieldAlert, inspection: ClipboardCheck, maintenance: Wrench, rental: KeyRound };

const AlertColumn = ({ type, items, onOpen }) => {
  const Icon = ICONS[type];
  const critical = items.filter((i) => i.level === 'critical').length;
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-3 min-w-0" data-testid={`vehicle-alerts-${type}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-slate-800 dark:text-slate-100"><Icon className="h-4 w-4 text-slate-500" />{WARN_TYPES[type].label}</span>
        <span className="text-xs">
          {critical > 0 && <span className="font-bold text-red-600">{critical} geçmiş</span>}
          {critical > 0 && items.length > critical && ' · '}
          {items.length > critical && <span className="font-bold text-orange-600">{items.length - critical} yaklaşan</span>}
        </span>
      </div>
      {items.length === 0 ? <p className="text-xs text-slate-400 py-2">Uyarı yok</p> : (
        <ul className="space-y-1 max-h-44 overflow-y-auto pr-1">
          {items.map((i) => (
            <li key={i.row.id}>
              <button type="button" onClick={() => onOpen(i.row)} data-testid={`vehicle-alert-item-${type}-${i.row.id}`}
                className={`w-full flex items-center justify-between gap-2 rounded-md px-2 py-1 text-left text-xs border transition-colors ${i.level === 'critical' ? 'bg-red-50 border-red-200 hover:bg-red-100 dark:bg-red-950/40 dark:border-red-900' : 'bg-orange-50 border-orange-200 hover:bg-orange-100 dark:bg-orange-950/30 dark:border-orange-900'}`}>
                <span className="font-mono font-bold text-slate-800 dark:text-slate-100">{i.row.license_plate}</span>
                <span className={i.level === 'critical' ? 'text-red-700 dark:text-red-300' : 'text-orange-700 dark:text-orange-300'}>{daysText(i.days)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export function VehicleAlerts({ rows, onOpen }) {
  const byType = Object.fromEntries(Object.keys(WARN_TYPES).map((k) => [k, []]));
  rows.forEach((r) => r.warnings.forEach((w) => byType[w.type]?.push({ ...w, row: r })));
  Object.values(byType).forEach((list) => list.sort((a, b) => a.days - b.days));
  const total = Object.values(byType).reduce((n, l) => n + l.length, 0);
  return (
    <section className="space-y-2" data-testid="vehicle-alerts-board">
      <h2 className="flex items-center gap-2 text-base font-semibold text-slate-900 dark:text-white">
        <AlertTriangle className="h-4 w-4 text-amber-500" />Araç Uyarıları <span className="text-xs font-normal text-slate-500">({total})</span>
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {Object.keys(WARN_TYPES).map((t) => <AlertColumn key={t} type={t} items={byType[t]} onOpen={onOpen} />)}
      </div>
    </section>
  );
}
